import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SecondaryButton } from 'components/Button';
import DividerComponent from 'components/Divider/Divider';
import { BoldSubtitle, Info } from 'components/Text';
import { REGISTER_VEHICLE_NEW } from 'routes/overview/RegisterVehicle/paths';
import { TRANSFER } from 'routes/overview/TransferTag/paths';
import RegisterVehicleLayout from '../RegisterVehicleLayout';
export default function IntroPage() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  return /*#__PURE__*/React.createElement(RegisterVehicleLayout, {
    onForwardButtonClick: () => push(REGISTER_VEHICLE_NEW),
    altForwardButtonText: t('register_vehicle.order_new_tag')
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h2"
  }, t('register_vehicle.existing_tag')), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.existing_tag_info')), /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: () => push(TRANSFER)
  }, t('buttons.transfer_tag')))), /*#__PURE__*/React.createElement(DividerComponent, null));
}